<article class="org-logo-upload">
  <div class="org-logo-upload-content">
    <!-- <header> -->
      <core-helpers-box-alert-message-icon
            [text]="'UPLOAD NEW LOGO'"
            [icon]="'warning'"
        ></core-helpers-box-alert-message-icon>
    <!-- </header> -->
    <div>
      <p>You are about to upload a new logo for your organization. The new logo will be used across all email notifications.</p>
    </div>
    <core-files-upload
      [multiple]="false"
      (response)="upload($event)"
    ></core-files-upload>
  </div>
  <fieldset>
    <!-- <core-helpers-forms-button [type]="'grey'" [text]="'GO BACK'" [disabled]="false" (click)="onCancel()"></core-helpers-forms-button> -->
    <core-helpers-forms-button-white [text]="'Next'" [disabled]="!ready" (click)="next()"></core-helpers-forms-button-white>
  </fieldset>
</article>
